<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal">
    <modal-header
      [plugin]="plugin"
      [menuModal]="modal"
      [menuComponent]="menuComponent"
      [(query)]="query"
      [enableSearch]="enableSearch"
    >
    </modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table parts-required-table">
          <tbody>
            <tr class="th-plugin-line-td--checkbox">
              <td class="check-box label" style="width: 300px" (click)="updateRequired()">
                <i class="material-icons" *ngIf="!isRequired()">check_box_outline_blank</i>
                <i class="material-icons" *ngIf="isRequired()">check_box</i>
                <span>{{ 'plugins.parts.required-spare' | translate }}</span>
              </td>
              <td>
                <input
                  placeholder="{{ 'plugins.parts.create-reminder' | translate }}"
                  name="comment"
                  [(ngModel)]="requiredParts.Comment"
                  class="ir-form-set"
                  type="text"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <table class="ir-plugin-table">
          <tr class="th-plugin-line--input">
            <td>
              <input type="text" class="ir-form-set" name="id" [(ngModel)]="filter.Id" />
            </td>
            <td>
              <input type="text" class="ir-form-set" name="page" [(ngModel)]="filter.Page" />
            </td>
            <td>
              <input type="text" class="ir-form-set" name="position" [(ngModel)]="filter.Position" />
            </td>
            <td>
              <input type="text" class="ir-form-set" name="partName" [(ngModel)]="filter.PartName" />
            </td>
            <td colspan="5">
              <div class="ir-btn th-btn-unactive">
                <i class="material-icons">search</i>
              </div>
            </td>
            <td class="th-plugin-line--numbers add-parts">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
          <tr class="th-plugin-line--header" style="font-size: 0.9em">
            <td class="th-plugin-line--data">
              <span>N°</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.pages' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.position' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.parts-name' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.total' | translate }}</span>
            </td>
            <td *ngIf="readonlyPrices" class="th-plugin-line--data">
              <span>{{ 'plugins.parts.quantity' | translate }}</span>
            </td>
            <td *ngIf="readonlyPrices" class="th-plugin-line--data">
              <span>{{ 'plugins.parts.add-remove' | translate }}</span>
            </td>
            <td class="th-plugin-line--data">
              <span>{{ 'plugins.parts.quotation' | translate }}</span>
            </td>
            <td class="th-plugin-line--data" colspan="2">
              <span>{{ 'common.currency' | translate }}</span>
            </td>
          </tr>
          <tr
            style="font-size: 0.9em"
            class="th-plugin-line--input"
            *ngFor="let part of pointParts | searchBy : query | partsFilter : filter; let i = index"
          >
            <td class="clickable" (click)="editPart(part)">
              <span>{{ part.Id }}</span>
            </td>
            <td class="clickable" (click)="editPart(part)">
              <span>{{ part.Page }}</span>
            </td>
            <td class="clickable" (click)="editPart(part)">
              <span>{{ part.Position }}</span>
            </td>
            <td class="clickable" (click)="editPart(part)">
              <span>{{ part.PartName }}</span>
            </td>
            <td class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  style="padding: 0.8em 0.4em 0.6em; text-align: left"
                  type="number"
                  name="part.Total-{{ i }}"
                  class="ir-form-set clickable"
                  (click)="copyTotalValue(part)"
                  [(ngModel)]="part.Total"
                  min="0"
                  readonly
                />
              </div>
            </td>
            <td *ngIf="readonlyPrices" class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  style="padding: 0.8em 0.4em 0.6em; text-align: left"
                  type="number"
                  name="part.Quantity-{{ i }}"
                  class="ir-form-set"
                  [(ngModel)]="part.Quantity"
                  min="0"
                />
              </div>
            </td>
            <td *ngIf="readonlyPrices" class="th-plugin-line--numbers">
              <i class="material-icons" *ngIf="part.Quantity > 0" (click)="updateQuantity(part, -1)">remove_circle</i>
              <i class="material-icons th-disabled" *ngIf="part.Quantity == 0">remove_circle</i>
              <i class="material-icons" (click)="updateQuantity(part, 1)">add_circle</i>
            </td>
            <td *ngIf="readonlyPrices">
              <span>{{ part.Quotation }}</span>
            </td>
            <td *ngIf="!readonlyPrices" class="th-plugin-line--value">
              <div class="ir-form-group margin">
                <input
                  style="padding: 0.8em 0.4em 0.6em; text-align: left"
                  type="number"
                  name="part.Quotation-{{ i }}"
                  class="ir-form-set"
                  [(ngModel)]="part.Quotation"
                  min="0"
                  [permissions]="[['disable', 'inspection.parts.quotation']]"
                />
              </div>
            </td>
            <td>
              <span>{{ part.Currency }}</span>
            </td>
            <td class="th-plugin-line--remove">
              <i
                class="material-icons"
                [ngClass]="{ 'th-disabled': checkPartInPoints(part) }"
                (click)="openDeletePartConfirm(part)"
                >delete</i
              >
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            (click)="save()"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
<modal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #deletePartConfirm
  (confirmOutput)="deletePart($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.parts.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<modal (modalOutput)="equipmentNumberSelected($event)" #equipmentModal></modal>
<modal (modalOutput)="catalogSelected($event)" #catalogModal></modal>
<modal (modalOutput)="partsviewModalClosed($event)" #partsviewModal></modal>
<modal (modalOutput)="partsViewEquipmentNumberSelected($event)" #partsViewEquipmentModal></modal>
